export const getHubspotutk = () => {
  // eslint-disable-next-line
  return document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");
};
